import React, { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import TextInput from "./TextInput"; // Adjust path accordingly
import { InputAdornment, Stack, Tooltip, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { isValidAmka } from "util/validators/amka-afm";
import { Check, Warning } from "@mui/icons-material";

const AmkaInput = (props) => {
  const { name, label, setParentState, ...other } = props;
  const { control } = useFormContext();
  const value = useWatch({ control, name });

  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    if (!value) setIsValid(null);
    else if (!value || value.length < 11) {
      if (setParentState) {
        setParentState(false);
      }
      setIsValid(false);
    } else {
      if (setParentState) {
        setParentState(true);
      }
      setParentState && setParentState(isValidAmka(value));
      setIsValid(isValidAmka(value));
    }
  }, [value]);

  return (
    <TextInput
      name={name}
      label={
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
          spacing={0}
        >
          <Typography>AΜΚΑ</Typography>
          {value && (
            <Tooltip
              title={
                isValid
                  ? "Έγκυρο ΑΜΚΑ"
                  : "Μη έγκυρο ΑΜΚΑ, αγνοήστε αν η χώρα έκδοσης δεν είναι Ελλάδα"
              }
              placement="top"
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                  borderRadius: 999,
                  background: isValid ? "#cefad0" : "#ff930010",
                  pl: 1,
                  pr: 1,
                }}
              >
                <Typography color={isValid ? "#008631" : "#ff9300"}>
                  {isValid ? "Έγκυρο" : "Προσοχή"}
                </Typography>
                {isValid ? (
                  <Check color="success" fontSize="small" />
                ) : (
                  <Warning sx={{ color: "#ff9300" }} />
                )}
              </Stack>
            </Tooltip>
          )}
        </Stack>
      }
      {...other}
      otherInputProps={{}}
    />
  );
};

export default AmkaInput;
